import { Injectable } from '@angular/core';
import { SharedService } from './shared.service';
import { HttpClient, HttpParams } from '@angular/common/http';
import { NotifyDialogService } from './notify-dialog.service';
import { environment } from '../../environments/environment';
import { FullSimulationReport, SimulationReturnValues, SimulationSavedConfig, SimulationSendValues } from '../interfaces/Simulation';
import { Observable } from 'rxjs';
import { ServerResponse, ServerResponseObject } from '../interfaces/ServerResponse';
import { SimulationNodeDataRequest, SimulationNodesDataResponse } from '../clases/SimulationValues';

@Injectable({
  providedIn: 'root'
})
export class SimulationService {

  API_URL = environment.API_URL;

  constructor(private http: HttpClient, public shared: SharedService, private notifyDialogService: NotifyDialogService) { }

  simulate(json: SimulationSendValues): Observable<ServerResponseObject<FullSimulationReport>> {
    let url = `${this.API_URL}/sim/simulate`;
    return this.http.post<ServerResponseObject<FullSimulationReport>>(url, json)
  }

  validate(json: SimulationSendValues): Observable<ServerResponseObject<{ valid: boolean; errors: string[]; warnings: string[] }>> {
    return this.http.post<ServerResponseObject<{ valid: boolean; errors: string[]; warnings: string[] }>>(`${this.API_URL}/sim/validate`, json);
  }

  download_file(path: string): Observable<Blob> {
    let url = `${this.API_URL}/sim/download_file`;
    const params = new HttpParams().set('file_name', path);
    return this.http.get(url, { params, responseType: 'blob' });
  }

  list_simulation_config(model_UUID: string, simulation_name: string = "", connectionString?: string): Observable<ServerResponse<SimulationSavedConfig>> {
    let url = `${this.API_URL}/sim/list_simulation_config_by_user`;
    let string_connection = connectionString ? connectionString : this.shared.data_service!.string_connection;
    return this.http.post<ServerResponse<SimulationSavedConfig>>(url, {
      string_connection,
      model_UUID,
      simulation_name
    })
  }

  get_simulation_config(simulation_UUID: string, connectionString?: string): Observable<ServerResponse<SimulationSavedConfig>> {
    const string_connection = connectionString ? connectionString : this.shared.data_service!.string_connection;
    return this.http.post<ServerResponse<SimulationSavedConfig>>(`${this.API_URL}/sim/get_simulation_config`, { string_connection, simulation_UUID });
  }

  save_simulation_config(simulation_structure: string, simulation_name: string, model_UUID: string, simulation_UUID: string = "", connectionString?: string): Observable<ServerResponseObject<SimulationSavedConfig>> {
    let url = `${this.API_URL}/sim/save_simulation_config`;
    let string_connection = connectionString ? connectionString : this.shared.data_service!.string_connection;
    return this.http.post<ServerResponseObject<any>>(url, {
      string_connection,
      model_UUID,
      simulation_UUID,
      simulation_name,
      simulation_structure
    })
  }

  remove_simulation_config(simulation_UUID: string, connectionString?: string): Observable<ServerResponse<SimulationSavedConfig>> {
    let url = `${this.API_URL}/sim/remove_simulation_config`;
    let string_connection = connectionString ? connectionString : this.shared.data_service!.string_connection;
    return this.http.post<ServerResponse<SimulationSavedConfig>>(url, {
      string_connection,
      simulation_UUID
    })
  }

  nodes_data_for_simulation(simulation_nodes: SimulationNodeDataRequest[], hierarchy_name: string, connectionString?: string): Observable<SimulationNodesDataResponse> {
    let url = `${this.API_URL}/sim/nodes_data_for_simulation`;
    let string_connection = connectionString ? connectionString : this.shared.data_service!.string_connection;
    return this.http.post<SimulationNodesDataResponse>(url, {
      string_connection,
      hierarchy_name,
      simulation_nodes
    })
  }

}
